'use strict';

import template from './customerIntegrationInput.html';
import controller from './customerIntegrationInput.controller';

const commonAttributes = 'ng-model="key.instance.value" ng-class="{\'configure_customer_disabled_field\' : vm.key.disabled === true }" ng-disabled="vm.key.disabled === true"';

const inputs = {
  text: `<input id="{{vm.keyName}}" type="text"  ${commonAttributes}/>`,
  select: `<select id="{{vm.keyName}}" ${commonAttributes}>
      <option ng-repeat="value in vm.key.values" value="{{value}}">{{value | translate}}</option>
   </select>`,
  checkbox: `<input id="{{vm.keyName}}" type="checkbox" ${commonAttributes}/>`
};

let customerIntegrationInputComponent = ($compile) => {
  return {
    restrict: 'E',
    scope: {
      key: '=',
      keyName: '=',
      error: '='
    },
    template,
    controller,
    controllerAs: 'vm',
    link: (scope, el) => {
      scope.vm = scope;

      if (!scope.key || !scope.keyName) {
        throw new Error('A key must be provided to this component.');
      }
      let inputTemplate = inputs[scope.key.input];
      let input = $compile(angular.element(inputTemplate))(scope);
      el.append(input);
    }
  };
};

customerIntegrationInputComponent.$inject = ['$compile'];
export default customerIntegrationInputComponent;



// WEBPACK FOOTER //
// ./app/components/customerIntegrationInput/customerIntegrationInput.component.js